<div class="step">
  <button class="td-btn-sm primary first-button" (click)="selectResponse(true)">Si</button>
  <button class="td-btn-sm primary" (click)="selectResponse(false)">No</button>
</div>
